import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { registerSelector, signinSelector } from '../../selectors/signin';
import { recoverPasswordRequest, setRecoverPassword, changePasswordRequest, cleanFlags } from '../../actions/signin';
import SigninLoader from './SigninLoader';
import { currentViewSelector } from '../../selectors/view';
import { setView } from '../../actions/view';

const mapStateToProps = createStructuredSelector({
    signin: signinSelector,
    register: registerSelector,
    currentView: currentViewSelector
});

const mapDispatchToProps = {
    recoverPasswordRequest,
    setRecoverPassword,
    changePasswordRequest,
    cleanFlags,
    setView
};

export default connect(mapStateToProps, mapDispatchToProps)(SigninLoader);